
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import PicParticles from '@/utils/PicParticles'

import { CountUp } from 'countup.js'
import * as echarts from 'echarts'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['canChange'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common

        const getParents = (node, name: string) => {
            const parent = node.parentNode
            if (!parent || !parent.className || parent.className.indexOf('.catering-list') > -1) return false
            if (parent.className.indexOf(name) > -1) {
                return true
            }
            getParents(parent, name)
        }

        const CountUpStart = (node) => {
            const num = node.innerText
            let options = {}
            if (num.indexOf('.') > -1) {
                options = {
                    useGrouping: false,
                    decimalPlaces: num.split('.')[1].length,
                    decimal: '.',
                }
            }
            const countUp = new CountUp(node, node.innerText, options)
            countUp.start()
        }

        const numCountUp = (node) => {
            const cs = node.querySelectorAll('.count-up')
            if (node.className.indexOf('count-up') > -1) {
                CountUpStart(node)
            }
            for (let i = 0; i < cs.length; i++) {
                CountUpStart(cs[i])
            }
        }

        const commonEvent = () => {
            const list = document.querySelector('.catering-wrapper .catering-list') as HTMLDivElement
            const ps = list.querySelectorAll('p, .line')
            for (let i = 0; i < ps.length; i++) {
                const p = ps[i] as HTMLParagraphElement
                let t = p.getBoundingClientRect().top - window.innerHeight / 2
                if (p.getBoundingClientRect().bottom - document.documentElement.scrollTop - p.getBoundingClientRect().bottom + document.documentElement.scrollTop <  window.innerHeight) {
                    t = p.getBoundingClientRect().bottom - window.innerHeight + window.innerWidth * .1
                }
                if (t <= 0) {
                    const cls = p.className
                    if (cls.indexOf('show') < 0) {
                        p.className += ' show'
                        numCountUp(p)
                    }
                }
            }
        }

        const scrollEvent = () => {
            imgParticlesEvent()
            commonEvent()
            echartInit()
        }

        const echartOptions = [
            {
                color:['#e0cbb3','#d97635'],
                series: [
                    {
                        name: 'echarts-1',
                        type: 'pie',
                        startAngle: 135,
                        radius: ['50%', '100%'],
                        label: {
                            show: false
                        },
                        data: [
                            { 
                                value: 765
                            },
                            { 
                                value: 235, 
                                itemStyle: {
                                    color: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [
                                            {
                                                offset: 0, color: '#e27933'
                                            },
                                            {
                                                offset: 1, color: 'rgba(226, 121, 51, 0)'
                                            }
                                        ],
                                        global: false
                                    }
                                },
                            },
                        ]
                    }
                ]
            },
            {
                grid: {
                    left: 0,    // 左边的距离
                    right: 0,   // 右边的距离
                    top: 0,     // 顶部的距离
                    bottom: 0   // 底部的距离
                },
                xAxis: {
                    type: 'value',
                    show: false
                },
                yAxis: {
                    type: 'category',
                    show: false
                },
                // 系列列表
                series: [
                    {
                        name: 'echarts-2',
                        type: 'bar',
                        barWidth: '80%', // 设置柱子宽度为30
                        data: [
                            {
                                value: 357,
                                itemStyle: {
                                    color: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 1,
                                        y2: 0,
                                        colorStops: [
                                            {
                                                offset: 0, color: 'rgba(244, 203, 179, 0)'
                                            },
                                            {
                                                offset: 1, color: '#e0cbb3'
                                            }
                                        ],
                                        global: false
                                    }
                                },
                            },
                            {
                                value: 643,
                                itemStyle: {
                                    color: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 1,
                                        y2: 0,
                                        colorStops: [
                                            {
                                                offset: 0, color: 'rgba(226, 121, 51, 0)'
                                            },
                                            {
                                                offset: 1, color: '#e27933'
                                            }
                                        ],
                                        global: false
                                    }
                                },
                            }
                        ]
                    }
                ]
            },
            {
                grid: {
                    left: 0,    // 左边的距离
                    right: 0,   // 右边的距离
                    top: 0,     // 顶部的距离
                    bottom: 0,   // 底部的距离
                },
                textStyle: {
                    fontFamily: 'jdzh',
                    fontSize: 16
                },
                xAxis: {
                    type: 'value',
                    show: false
                },
                yAxis: {
                    type: 'category',
                    data: ['2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014'],
                    axisLabel: {
                        inside: true,
                        color: '#a06a3d',
                        fontSize: 16
                    },
                    axisLine: {
                        show: false
                    },
                },
                // 系列列表
                series: [
                    {
                        name: 'echarts-3',
                        type: 'bar',
                        barWidth: '80%', // 设置柱子宽度为30
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [
                                    {
                                        offset: 0, color: 'rgba(159, 105, 61, 0)'
                                    },
                                    {
                                        offset: 1, color: '#9f693d'
                                    }
                                ],
                                global: false
                            }
                        },
                        label: {
                            show: true,
                            position: 'insideRight',
                            color: '#ebd9c2'
                        },
                        data: [52890, 43941, 46895, 39527, 46721, 42716, 39644, 35799, 32310, 27860]
                    }
                ]
            },
            {
                color:['#d97635', '#e0cbb3'],
                series: [
                    {
                        name: 'echarts-4',
                        type: 'pie',
                        radius: ['75%', '100%'],
                        label: {
                            show: false
                        },
                        data: [
                            { 
                                value: 79,
                            },
                            { 
                                value: 921
                            },
                        ]
                    }
                ]
            },
        ]

        let myCharts: any[] = []
        const echartInit = () => {
            const echartsNodes = document.querySelectorAll('.catering-wrapper .echarts')
            for (let i = 0; i < echartsNodes.length; i++) {
                const node = echartsNodes[i] as HTMLDivElement
                !myCharts[i] && myCharts.push({
                    echart: echarts.init(node),
                    isLoad: false
                })
                if (node.getBoundingClientRect().top - window.innerHeight / 2 < 0 && !myCharts[i].isLoad) {
                    myCharts[i].echart.setOption(echartOptions[i])
                    myCharts[i].isLoad = true
                }
            }   
        }

        let titleParticles: any = null
        const titleEvent = () => {
            const title = document.querySelector('.catering-wrapper .title') as HTMLDivElement
            if (!titleParticles) {
                titleParticles = new PicParticles({
                    container: title,
                    imgUrl: require('../../assets/img/catering/title_bg.png'),
                    pix: 30,
                    radius: 60,
                    duration: 2000
                })
            }
        }

        let imgParticles: any = null
        const imgParticlesEvent = () => {
            const particles = document.querySelector('.catering-wrapper .particles') as HTMLDivElement
            if (!imgParticles && particles.getBoundingClientRect().top - window.innerHeight / 2 <= 0) {
                imgParticles = new PicParticles({
                    container: particles,
                    imgUrl: require('../../assets/img/catering/pic.png'),
                    pix: 10,
                    duration: 2000
                })
            }
        }

        const init = () => {
            titleEvent()
            scrollEvent()
            window.addEventListener('scroll', scrollEvent, false)
        }

        watch(() => props.canChange, (to, from) => {
            if (to) {          
                init()
            }
        })

        onBeforeUnmount(() => {
            if (titleParticles) {
                titleParticles.forceDestroy()
                titleParticles = null
            }
            window.removeEventListener('scroll', scrollEvent, false)
            myCharts.forEach((e) => {
                if (e.echart != null && e.echart.dispose) {
                    e.echart.dispose()
                    e.echart = null
                }
            })
        })

        onMounted(() => {
            if(props.canChange) {
                init()
            }
        })    

        return {
            
        }
    }
})
